import {
  ConsentCallbackQueueResolver,
  ConsentCategoriesResolver,
} from "../types";

export const oneTrustCategoriesMap = {
  C0001: "necessary",
  C0002: "performance",
  C0003: "functional",
  C0004: "targeting",
  C0005: "social",
};

export class OnetrustApiConsentResolver implements ConsentCategoriesResolver {
  constructor(
    private container: Window,
    queueResolver: ConsentCallbackQueueResolver,
  ) {
    const oldOptanonWrapper = container.OptanonWrapper;

    container.OptanonWrapper = () => {
      queueResolver.resolve();
      oldOptanonWrapper?.();
    };
  }

  available(): boolean {
    return this.container.OneTrust !== undefined;
  }

  ready(): boolean {
    const api = this.container.OneTrust;
    return (
      this.container.OnetrustActiveGroups !== undefined &&
      (api.GetDomainData()?.ConsentModel?.Name !== "opt-in" ||
        api.IsAlertBoxClosed())
    );
  }

  resolve(): Categories {
    return this.container.OnetrustActiveGroups?.split(",")
      .map((g) => oneTrustCategoriesMap[g])
      .filter((g) => g)
      .reduce((a, v) => ({ ...a, [v]: true }), {});
  }
}
